import ContainerLayout from "../../layout/ContainerLayout";
import coding from '../../resources/coding.svg';
import chances_research from '../../resources/chances_researcher.svg';
import researcher2 from '../../resources/Research2.svg';
import researcher from '../../resources/researcher.svg';
import graphic from '../../resources/graphic designer.svg';
import web_design from '../../resources/WEB_DESIGN.svg';
import { motion } from "framer-motion";

const members = [
  { id: 1, name: "Yousef Elsebaey",      role: "Founder & Developer",        Img: coding,            sentence: 'Founded, managed and developed Campus Odyssey with attention to detail and user experience.', contact: "https://www.linkedin.com/in/youssef-elsebaey-b67343326/" },
  { id: 2, name: "Yousef Abo Serag",     role: "Founder & Content Writer",   Img: researcher,        sentence: "Founded, researched and co-wrote the entire website content. Manages social media.",           contact: "https://www.linkedin.com/in/yousef-aboserag-a2197037b/" },
  { id: 3, name: "Abdelrahman Dahman",   role: "UI/UX Designer",             Img: web_design,        sentence: "Designed the entire Campus Odyssey website and guided development to ensure quality.",          contact: "https://www.linkedin.com/in/ab-dahman/" },
  { id: 4, name: "Abdelrahman Elkholy",  role: "Content Writer",             Img: researcher2,       sentence: "Researched and co-wrote the entire content of the website.",                                   contact: "https://www.linkedin.com/in/abdelrhman-elkholy-025996340/" },
  { id: 5, name: "Eiad Elmeligy",        role: "Graphic Designer",           Img: graphic,           sentence: "Created all artworks and visuals for Campus Odyssey, ensuring a cohesive design.",             contact: "https://www.linkedin.com/in/eiad-almeligy-6a09701b9/" },
  { id: 6, name: "Mohaned Elshater",     role: "Opportunities Researcher",   Img: chances_research,  sentence: "Researched all opportunities for the programs and competition sections.",                       contact: "https://www.linkedin.com/in/mohanad-elshater-47abab353/" },
];

const roleStyle = {
  "Founder & Developer":       "bg-blue-900/30 text-blue-400 border-blue-800/40",
  "Founder & Content Writer":  "bg-blue-900/30 text-blue-400 border-blue-800/40",
  "UI/UX Designer":            "bg-purple-900/30 text-purple-400 border-purple-800/40",
  "Content Writer":            "bg-emerald-900/30 text-emerald-400 border-emerald-800/40",
  "Graphic Designer":          "bg-pink-900/30 text-pink-400 border-pink-800/40",
  "Opportunities Researcher":  "bg-amber-900/30 text-amber-400 border-amber-800/40",
};

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" className="w-[14px] h-[14px] fill-current shrink-0">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const Card = ({ member, order }) => {
  const badge = roleStyle[member.role] || "bg-gray-900/30 text-gray-400 border-gray-700/40";
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: order * 0.07, duration: 0.45, ease: "easeOut" }}
      viewport={{ once: true }}
      className="group relative bg-[#111] border border-white/[0.07] rounded-2xl overflow-hidden flex flex-col hover:border-[#3555C6]/40 transition-all duration-300 hover:shadow-[0_0_24px_rgba(53,85,198,0.08)]"
    >
      {/* Hover top accent */}
      <div className="absolute top-0 inset-x-0 h-[2px] bg-gradient-to-r from-transparent via-[#3555C6] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      {/* Illustration area */}
      <div className="h-[160px] bg-[#0A0A0A] flex items-center justify-center px-6 pt-5">
        <img src={member.Img} alt={member.name} className="h-full w-auto object-contain" />
      </div>

      {/* Content */}
      <div className="flex flex-col flex-1 p-5 gap-4">
        {/* Name + badge — always English, so LTR left-aligned */}
        <div className="flex flex-col gap-2 items-start" dir="ltr">
          <h3 className="text-white text-[17px] font-semibold leading-snug text-left">{member.name}</h3>
          <span className={`text-[11px] font-medium px-2.5 py-1 rounded-full border ${badge}`}>
            {member.role}
          </span>
        </div>

        {/* Description — English sentence, LTR left-aligned */}
        <p className="text-[#888] text-[13px] leading-relaxed text-left flex-1" dir="ltr">
          {member.sentence}
        </p>

        {/* LinkedIn button — English, LTR */}
        <a
          dir="ltr"
          href={member.contact}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl text-[13px] font-medium
            bg-[#0A66C2]/10 border border-[#0A66C2]/25 text-[#4D9FE0]
            hover:bg-[#0A66C2]/20 hover:border-[#0A66C2]/50 hover:text-[#6AB4F5]
            transition-all duration-200"
        >
          <LinkedInIcon />
          Connect on LinkedIn
        </a>
      </div>
    </motion.div>
  );
};

function CardsSection() {
  return (
    <section className="py-24 bg-[#0A0A0A] border-t border-white/[0.04]">
      <ContainerLayout>
        {/* Header */}
        <div className="text-center mb-14" dir="rtl">
          <p className="text-[#3E7CFF] text-[13px] font-semibold tracking-widest uppercase mb-3" dir="ltr">The Team</p>
          <h2 className="text-white text-[40px] font-bold leading-tight">الفريق وراء Campus Odyssey</h2>
          <p className="text-[#666] text-[15px] mt-3">طلاب ثانوي بيساعدوا طلاب ثانوي</p>
        </div>

        {/* Grid */}
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5">
          {members.map((member, i) => (
            <Card key={member.id} member={member} order={i} />
          ))}
        </div>
      </ContainerLayout>
    </section>
  );
}

export default CardsSection;
